import { useRef, useState } from 'react';
import { useReduxState } from 'hooks';
import api from 'api';
import { ModalButtonWithForm } from 'components/common';
import { TwoFactorSetup, TwoFactorSuccess } from 'components/common/auth';

import type { FormApi } from 'informed';

interface Props {
  isSharedConfiguration?: boolean;
  onActivated: () => Promise<void> | void;
  secret: string;
}

const ProfileAuthTwoFactorSetup = ({
  isSharedConfiguration = false,
  onActivated,
  secret
}: Props) => {
  const { messages, user } = useReduxState();

  const formApi = useRef<FormApi>(null);

  const [backupCodes, setBackupCodes] = useState<string[] | null>(null);

  const verify = async (values) => {
    const response = await api.post(
      `/auth/totp/activate` +
        (isSharedConfiguration ? '?isSharedConfigured=true' : ''),
      { code: values.verificationCode, secret }
    );

    if (response?.data?.success) {
      setBackupCodes(response.data.backupCodes);
    } else if (response?.data?.error === 'invalid_code') {
      formApi.current.setError(
        'verificationCode',
        messages.authTwoFactorInvalidCode
      );
    } else {
      throw new Error('error');
    }

    return false;
  };

  return (
    <ModalButtonWithForm
      buttonCategory="success"
      buttonText={messages.commonActivate}
      footerCloseButton={Boolean(backupCodes)}
      modalActionText={messages.authTwoFactorVerifyAndActivate}
      modalAutoFocus={false}
      modalTitle={messages.authTwoFactorAuthentication}
      modalWidth="medium"
      onHide={backupCodes ? onActivated : null}
      onSubmit={verify}
      pristineIsValid={false}
      setFormApi={(form) => (formApi.current = form)}
    >
      {() => (
        <div className="content">
          {backupCodes ? (
            <div className="success">
              <TwoFactorSuccess isSharedConfigured={isSharedConfiguration} />
            </div>
          ) : (
            <div className="setup">
              <TwoFactorSetup
                secret={secret}
                userEmail={
                  isSharedConfiguration
                    ? 'vuolearningSharedTwoFactorUser'
                    : user?.email || user?.username
                }
              />
            </div>
          )}
        </div>
      )}
    </ModalButtonWithForm>
  );
};

export default ProfileAuthTwoFactorSetup;
